
/* injects from baggage-loader */

import { CharThumbs } from '_appRoot/index.const';

export const introBallons = [
    'Chegamos à Montanha de Litera! Aqui as palavras correm pelos rios e as gotas das chuvas caem em forma de letras!',
    'Para derrotar, finalmente, o Albedo, você precisará vencê-lo em uma batalha final.',
    'Leia com atenção os quadrinhos e descubra os mistérios escondidos na Montanha de Litera!'
]
export const tutorialBallons = [
    'Duvido que você seja capaz de decifrar a expressão do rosto de liz!'
];

export const abeldoChallenge1Ballons = [
    '<small>Quero ver você conseguir me vencer nesta batalha final! Você deve ler com atenção os quadrinhos para descobrir os seus mistérios...</small>'
];

export const abeldoChallenge2Ballons = [
    'Agora, eu o desafio a decifrar a expressão do rosto do pai de Liz!'
];

export const successExercise1 = [
    ' Muito bem! <br> Os quadrinhos mostram a história de uma mulher e os seus feitos em sua vida profissional e pessoal.'
];

export const failExercise1 = [
    'Parece que a opção marcada não está relacionada à temática principal dos quadrinhos. Leia com atenção e tente outra vez.'
];

export const successExercise2 = [
    'Muito bem! <br> Nos quadrinhos, Liz dá vida à sua boneca e cria toda uma história para ela!'
];

export const failExercise2 = [
    'Parece que a opção marcada não está relacionada à forma como a história é retratada. Leia com atenção e tente outra vez.'
];

export const successExercise3 = [
    'Muito bem! <br> A expressão de Liz, as linhas ao lado de sua cabeça e o balão de fala presentes na cena revelam que a brincadeira foi interrompida,',
    'pois alguém chamou Liz.'
];

export const failExercise3 = [
    'Parece que a opção marcada não está relacionada aos eventos dos quadrinhos. Observe com atenção e tente outra vez.'
];

export const successExercise4 = [
    'Muito bem! Os quadrinhos mostram diversas profissões, menos a de dentista.'
];

export const failExercise4 = [
    '<small>Parece que a opção marcada não está relacionada às profissões que aparecem ao longo dos quadrinhos. Leia com atenção e tente outra vez.</small>'
];

export const successExercise5 = [
    'Muito bem! <br> As linhas usadas ao lado da cabeça de Liz e os olhos arregalados',
    'mostram que a garotinha ficou assustada com o chamado de alguém.'
];

export const failExercise5 = [
    'Parece que a opção marcada não está relacionada à forma como a história é retratada. Leia com atenção e tente outra vez.'
];

export const successExercise6 = [
    'Isso aí! <br> As reticências utilizadas mostram que algo ainda está por vir, indicando que',
    'o autor não quis revelar alguns aspectos da história logo no início.'
];

export const failExercise6 = [
    'Parece que a opção marcada não está relacionada ao uso das reticências nos quadrinhos. Leia com atenção e tente outra vez.'
];

export const scene1 = [
    {
        bg: require('_images/stages/stage-four/croma-abeldo-dialogs/scene-1.png'),
        text: ['Encontrei você, Albedo!'],
        thumb: CharThumbs.croma,
        visible: false
    },
    {
        bg: require('_images/stages/stage-four/croma-abeldo-dialogs/scene-2.png'),
        text: ['Ahhhhhhhh!!!'],
        thumb: CharThumbs.abeldo,
        visible: false
    },
];


export const scene2 = [
    {
        bg: require('_images/stages/stage-four/croma-abeldo-dialogs/scene-3.png'),
        text: [
            'Consegui recuperar as páginas perdidas! Que alegria! A harmonia, agora, pode retornar para o mundo dos quadrinhos.',
            'Agora, também, podemos conhecer o mundo de liz. <br> O que você acha? Vamos Lá?!'
        ],
        thumb: CharThumbs.croma,
        visible: false
    }
];


export const exercise1 = [
    {
        value: 1,
        text: 'As profissões de uma mulher.'
    },
    {
        value: 2,
        text: 'A vida de uma das bonecas de Liz.'
    },
    {
        value: 3,
        text: 'O casamento do pai de Liz com a sua mãe.'
    },
    {
        value: 4,
        text: 'A fantasia de uma menina sobre a vida adulta.'
    },
];

export const exercise2 = [
    {
        value: 1,
        text: 'Por meio de uma brincadeira de boneca.'
    },
    {
        value: 2,
        text: 'Por meio de uma explicação feita a outra pessoa.'
    },
    {
        value: 3,
        text: 'Por meio de um filme que Liz assistiu na televisão.'
    },
    {
        value: 4,
        text: 'Por meio de uma conversa que Liz teve com o seu pai.'
    },
];

export const exercise3 = [
    {
        value: 1,
        text: 'Liz empresta a sua boneca para uma amiga.'
    },
    {
        value: 2,
        text: 'O filme acaba. Então, Liz não pode continuar assistindo-o.'
    },
    {
        value: 3,
        text: 'A boneca de Liz quebra e a brincadeira não tem continuidade.'
    },
    {
        value: 4,
        text: 'Alguém chama Liz para o lanche e a brincadeira é interrompida.'
    },
];

export const exercise4 = [
    {
        value: 1,
        text: 'Estilista'
    },
    {
        value: 2,
        text: 'Dentista.'
    },
    {
        value: 3,
        text: 'Bailarina.'
    },
    {
        value: 4,
        text: 'Arquiteta.'
    },
];

export const exercise5 = [
    {
        value: 1,
        text: 'Liz ficou assustada, após alguém tê-la chamado.'
    },
    {
        value: 2,
        text: 'Liz está com medo, pois a sua boneca está falando.'
    },
    {
        value: 3,
        text: 'Liz está feliz, pois está brincando de algo que ela gosta.'
    },
    {
        value: 4,
        text: 'Liz ficou nervosa quando percebeu que a sua boneca quebrou.'
    },
];

export const exercise6 = [
    {
        value: 1,
        text: 'Mostra que a história não terá um fim.'
    },
    {
        value: 2,
        text: 'É apenas um recurso visual sem impacto na história.'
    },
    {
        value: 3,
        text: 'Apresenta uma pergunta que será respondida por alguém.'
    },
    {
        value: 4,
        text: 'Indica que haverá uma continuidade de fala no próximo quadrinho.'
    },
];


// WEBPACK FOOTER //
// ./src/app/pages/stage-four/stage-four.const.js